'use strict'; // https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var _typeof = require("/source/phone-lead-client/node_modules/@babel/runtime/helpers/typeof");

module.exports = function IsPropertyKey(argument) {
  return typeof argument === 'string' || _typeof(argument) === 'symbol';
};